import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ListItemText from "@material-ui/core/ListItemText";
import { useHistory, useRouteMatch, useLocation } from "react-router-dom";
import {
  prospectPath,
  beigeManagementPath,
  searchFilter,
  handleSort,
} from "../utils/varialbles";
import http from "../services/httpService";
import toast, { Toaster } from "react-hot-toast";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    position: "relative",
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerContainer: {
    overflow: "auto",
    position: "static",
    marginTop: 65,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  colorWhite: {
    color: "white",
  },
  colorGray: {
    color: "#BABABA",
  },
  colorBlack: {
    color: "#fff",
  },
}));

function SideBar({ toggle, setToggle }) {
  const classes = useStyles();
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [selectedSales, setSelectedSales] = useState();
  const [menuItems, setMenuItems] = React.useState([]);
  const [isMisChildOpen, setMisChildOpen] = useState(false);
  let history = useHistory();
  let match = useRouteMatch();
  const location = useLocation();

  const handleListItemClick = (event, index, menuObject) => {
    setSelectedIndex(index);
    if (menuObject.name === "MIS Report") {
      setMisChildOpen(!isMisChildOpen);
      setSelectedSales();
    } else {
      setMisChildOpen(false);
    }
    if (window.screen.width < 960) {
      setToggle(false);
    }
    if (menuObject.link !== undefined) {
      history.push(`${match.url}` + menuObject.link);
    } else {
      // history.push(`${match.url}`);
      // subMenusLink(index, menuObject)
    }
    if (menuObject.name === "Onboarding Manager") {
      localStorage.removeItem("manager");
      localStorage.setItem("manager", "onboarding");
    } else if (menuObject.name === "Investor Manager") {
      localStorage.removeItem("manager");
      localStorage.setItem("manager", "investor");
    }
  };
  // for mis report child sub menus
  const subMenusLink = (event, index, menuObject) => {
    setSelectedSales(index);
    if (menuObject.link) {
      history.push(`${match.url}` + menuObject.link);
    } else {
      history.push(`${match.url}`);
    }
  };
  const menuItemsArray = [
    {
      name: "Prospect Manager",
      link: "/prospect",
      default: true,
      subMenu: false,
    },
    {
      name: "Onboarding Manager",
      link: "/OnboardingManagar",
    },
    { name: "Investor Manager", link: "/investmentOverView" },
    { name: "APART", link: "/Synapse" },
    // { name: 'CEO Dashboard' },
    { name: "Broker Manager", link: "/broker_manager" },
    { name: "User Management", link: "/user_management" },
    // { name: 'FAQ Manager' },
    // { name: 'Employee Attendance' },
    { name: "Referral Manager", link: "/referral_manager" },
    { name: "Content Management System", link: "/content_management" },
    { name: "Beige - Event Management", link: "/beige_management" },
    { name: "Lookup Manager", link: "/lookup_manager" },
    { name: "Call Requests", link: "/callRequests" },
    { name: "Internal Support", link: "/viewinternalsupport" },
    { name: "MIS Report" },
    { name: "Research Dashboard", link: "/manualadvices" },
    { name: "Create URL", link: "/createfranchise" },
    { name: "Bulk Upload", link: "/uploadexcel" },
    // { name: "Gromo Link", link: "/gromo_code" },
    { name: "MF EOD", link: "/uploadexcel" },
    // {name: "Request to Pay", link: "/razorpy"},
    { name: "MF Upload", link: "/upload_excel_mutualfunds" },
    { name: "AUA", link: "/aua_proposal" },
  ];
  // mis child reports links
  const childMenus = [
    {
      name: "Research",
      link: "/viewresearchreports",
    },
    {
      name: "BGT",
      link: "/viewallcdtreports",
    },
    {
      name: "CDT",
      link: "/viewsalesmisreports",
    },
    {
      name: "Marketing",
      link: "/marketing",
    },
    {
      name: "Portfolio Review",
      link: "/portfolioreview",
    },
  ];
  // useEffect(() => {
  //   http
  //     .get("/login_permissions")

  //     .then((res) => {
  //       // (res);
  //       if (
  //         res &&
  //         res.data &&
  //         res.data.Data &&
  //         Array.isArray(res.data.Data) &&
  //         res.data.Data.length > 0
  //       ) {
  //         let menuTemp = [];
  //         let data = res.data.Data;

  //         let permitedMenu = data.map((obj) => {
  //           return menuItemsArray.filter((permited) => {
  //             return permited.name === obj.Mainmenu;
  //           });
  //         });
  //         permitedMenu = permitedMenu.flat();

  //         console.log(permitedMenu, "permitedMenu");
  //         setMenuItems(permitedMenu);
  //         history.push(`${match.url}` + permitedMenu[0]["link"]);
  //         setSelectedIndex(0);
  //       } else {
  //         toast.error("You are not authorized to access this application!");
  //       }
  //     })
  //     .catch((err) => {});
  // }, []);

  useEffect(() => {
    http
      .get("/login_permissions")
      .then((res) => {
        if (
          res &&
          res.data &&
          res.data.Data &&
          Array.isArray(res.data.Data) &&
          res.data.Data.length > 0
        ) {
          const data = res.data.Data;
          const permittedMenuNames = new Set(data.map((obj) => obj.Mainmenu));

          // Filter menuItemsArray based on permitted menu names and maintain order
          const filteredMenuItems = menuItemsArray.filter((menuItem) =>
            permittedMenuNames.has(menuItem.name)
          );

          if (filteredMenuItems.length > 0) {
            setMenuItems(filteredMenuItems);

            // Find the index of the first permitted menu item
            const firstPermittedIndex = menuItemsArray.findIndex((menuItem) =>
              permittedMenuNames.has(menuItem.name)
            );

            if (firstPermittedIndex !== -1) {
              history.push(
                `${match.url}` + menuItemsArray[firstPermittedIndex].link
              );
              setSelectedIndex(firstPermittedIndex);
            }
          } else {
            toast.error("You are not authorized to access this application!");
          }
        } else {
          toast.error("You are not authorized to access this application!");
        }
      })
      .catch((err) => {});
  }, []);

  return (
    <div className={classes.root}>
      <Drawer
        className={classes.drawer}
        variant="persistent"
        open={toggle}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.drawerContainer}>
          <List>
            {menuItems.map((text, index) => (
              <>
                <ListItem
                  button
                  key={text.name}
                  className={
                    selectedIndex === index
                      ? classes.colorWhite
                      : classes.colorGray
                  }
                  selected={selectedIndex === index}
                  onClick={(event) => handleListItemClick(event, index, text)}
                >
                  <ListItemText primary={text.name} />
                  {text.name === "MIS Report" ? (
                    <>
                      {" "}
                      {isMisChildOpen ? (
                        <KeyboardArrowUpIcon />
                      ) : (
                        <KeyboardArrowDownIcon />
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </ListItem>
                {isMisChildOpen === true && text.name === "MIS Report" ? (
                  <>
                    {childMenus.map((text, i) => (
                      <>
                        <ListItem
                          button
                          key={text.name}
                          className={
                            selectedSales === i
                              ? classes.colorBlack
                              : classes.colorGray
                          }
                          selected={selectedSales === i}
                          onClick={(event) => subMenusLink(event, i, text)}
                        >
                          <ListItemText
                            primary={text.name}
                            style={{ paddingLeft: "20px" }}
                          />
                        </ListItem>
                      </>
                    ))}
                  </>
                ) : (
                  ""
                )}
              </>
            ))}
          </List>
        </div>
      </Drawer>
    </div>
  );
}
export default SideBar;
